<div class="main-content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">

                <div class="d-sm-flex align-items-center justify-content-between mb-4 margin-bottom">
                    <h1 class="h3 mb-0 text-gray-800">Email Template</h1>
                    <div class="btns-container">
                        <div class="margin-right-5">
                            <ng-container *ngIf="templateId!==0">
                                <a (click)="openConfirmationModal()" class="btn btn-red shadow-sm">
                                    <i class="fas fa-trash-alt text-white-50"> <span class="button-text">Delete</span></i>
                                </a>
                            </ng-container>
                        </div>
                        <div>
                            <a (click)="saveTemplate(_name.value, _type.value, _purpose.value, '1', _userType.value )" class="btn btn-primary shadow-sm">
                                <i class="fas fa-save text-white-50"> <span class="button-text">Save</span></i>
                            </a>
                        </div>
                    </div>
                </div>


                <div class="panel-group main-container col-md-12 shadow" id="mainAccordion" style="height: 50px;">
                    <div class="panel panel-default">
                        <!--(click)="changeTitle(fieldsOpen)"-->
                        <div class="panel-heading fieldsTitle" id="{{fieldsOpen}}" data-toggle="collapse" data-parent="#mainAccordion" href="#collapse">
                            <h4 class="panel-title">
                                <a>
                                    Details
                                </a>
                            </h4>
                        </div>
                        <div id="collapse" class="panel-collapse collapse in">
                            <div class="panel-body">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-12">
                                            <label>Name: </label>
                                            <input #_name type="text" id="emailTemplateName" value="{{name}}" />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Assessment type: </label>
                                            <select id="aType" #_type>
                                                <!--(change)="getSelectedOptionText($event)"-->
                                                <!--<option *ngFor="let _type of types" [selected]="type == _type.Id" value="{{_type.Id}}">{{_type.Name}}</option>-->

                                                <option *ngFor="let _type of assessmentsTypes" [selected]="type == _type.Id" [value]="_type.Id">{{_type.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <!--<div class="row">
                    <div class="col-12">
                        <label>Niche: </label>
                        <select id="aNiche" #_niche>
                            <option *ngFor="let _niche of niches" [selected]="niche == _niche.Id" value="{{_niche.Id}}">{{_niche.Name}}</option>
                        </select>
                    </div>
                </div>-->

                                    <div class="row">
                                        <div class="col-12">
                                            <label>User Type: </label>
                                            <select id="aUserType" #_userType>
                                                <option *ngFor="let _usertype of userTypes" [selected]="userType == _usertype.Id" value="{{_usertype.Id}}">{{_usertype.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Purpose: </label>
                                            <select id="aPurpose" #_purpose>
                                                <option *ngFor="let _purpose of purposes" [selected]="purpose == _purpose.Id" value="{{_purpose.Id}}">{{_purpose.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Language: </label>
                                            <select id="languages" #_languageShortCode (change)="checkData(_languageShortCode.value, _subject.value)" (focusin)="addLocalization(_languageShortCode.value, _subject.value )">
                                                <option *ngFor="let _language of languages" [selected]="language == 'en'" class="option" value="{{_language.ShortCode}}">{{_language.Name}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-12">
                                            <label>Subject: </label>
                                            <input #_subject (keypress)="preventSpace(_subject.value, $event)" (keyup)="preventSpace(_subject.value, $event)" type="text" id="subject" value="" placeholder="Subject" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="panel panel-default">
                            <div class="panel-heading" data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                <h4 class="panel-title">
                                    <a data-toggle="collapse" data-parent="#mainAccordion" href="#collapseEditor">
                                        Body
                                    </a>
                                </h4>
                            </div>

                            <div id="collapseEditor" class="panel-collapse collapse in">
                                <div class="panel-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="body-content">
                                                <!--<button (click)="insertCustomText()">insert text</button>
                            <button (click)="insertCustomImages()">insert images</button>-->

                                                <br />
                                                <!--[options]="editorOptions"-->
                                                <quill-editor #editor
                                                              [(ngModel)]="editorContent"
                                                              (blur)="onEditorBlured($event)"
                                                              (focus)="onEditorFocused($event)"
                                                              (onEditorCreated)="onEditorCreated($event)"
                                                              (onContentChanged)="onContentChanged($event)"></quill-editor>

                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="customFields">
                                                <div class="panel-group" id="accordion">

                                                    <div *ngFor="let field of templateFields; let i = index" class="panel panel-default">
                                                        <div class="panel-heading" data-toggle="collapse">
                                                            <h4 class="panel-title">
                                                                <a data-toggle="collapse" data-parent="#accordion" href="#group{{i}}">{{field.Name}} Fields</a>
                                                            </h4>
                                                        </div>
                                                        <div id="group{{i}}" class="panel-collapse collapse" [ngClass]="{'in': i == 0}">
                                                            <div class="panel-body">
                                                                <ul style="list-style: disc !important;">
                                                                    <li *ngFor="let item of field.Fields">
                                                                        <button (click)="insertCustomFields(item.Name)">{{item.Name}}</button>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                </div>

            </div>
        </div>
    </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="confirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h2 class="modal-title text-center">Delete Email Template</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body text-center">
                <p>Are you sure you want to delete this <b>Email Template</b>?</p>
            </div>

            <div class="modal-footer">
                <div class="row">
                    <div class="col-md-12">
                        <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                        <button (click)="deleteEmailTemplate()" type="button" class="btn btn-primary">Yes</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>